import {  collection, doc, getDoc, getDocs, getFirestore,  query, where, serverTimestamp, updateDoc, setDoc, limit, orderBy, collectionGroup, startAfter, increment } from "firebase/firestore";


//* Exam collection
async function getFirebaseExams(searchField = "examNameForSearch", lastDoc, examSearchValue) {

    if (searchField === "examNameForSearch" && examSearchValue) {
      examSearchValue = examSearchValue.toLowerCase();
    }
  
    console.log({ searchField, lastDoc, examSearchValue });
    let examRef = collection(getFirestore(), 'exams');
    
    let _query = query(examRef, orderBy(searchField, "asc"), limit(12));  //* for first time visit and without search
    if (lastDoc && !examSearchValue) {
      //* for next docs without Search
      _query = query(examRef, orderBy(searchField, "asc"), startAfter(lastDoc), limit(12))
    }
    if (examSearchValue && !lastDoc) {
      //* for search first time without last
      _query = query(examRef, orderBy(searchField, "asc"), where(searchField, ">=", examSearchValue), where(searchField, "<=", examSearchValue + "\uf8ff"), limit(12));
    }
    if (lastDoc && examSearchValue) {
      //* for search time with last doc
      _query = query(examRef, orderBy(searchField, "asc"), startAfter(lastDoc), where(searchField, ">=", examSearchValue), where(searchField, "<=", examSearchValue + "\uf8ff"), limit(12));
    }
    let getStudents = getDocs(_query);
    
    return getStudents;
  }



//*Update Students Count
 async function getStudentsData() {
   return await updateDoc(doc(getFirestore(), `StudentCount`, "1"), { studentCount : increment(1) })
 }



//*Applicants collection

async function getApplicants(uid){
    const ApplicantsRef = collectionGroup(getFirestore() , 'Applicants');
    return await getDocs(query(ApplicantsRef ,orderBy("Full Name" , "asc"),where("studentID", "==", uid) , limit(12)))
    
}

async function getNextPendingExams(lastVisible , uid) {
    const PendingRef = collectionGroup(getFirestore(), 'Applicants');
    return await getDocs(query(PendingRef ,orderBy("Full Name" , "asc"),where("studentID", "==", uid) ,startAfter(lastVisible),limit(2)));
}

//* Admit Cards

async function getAdmitApplicants(uid){
    const ApplicantsRef = collectionGroup(getFirestore() , 'Applicants');
    return await getDocs(query(ApplicantsRef ,orderBy("Full Name" , "asc"),where("studentID", "==", uid) , limit(12)))
    
}

async function getNextAdmitCard(lastVisible) {
    const AdmitCardRef = collection(getFirestore(), 'exams');
    return await getDocs(query(AdmitCardRef,orderBy("name"),startAfter(lastVisible),limit(2)));
}


//*Students collection (profile ,  Signup)

async function getStudents() {
    const studentsRef = collection(getFirestore(), 'students');
    return  await getDocs(query(studentsRef))
}

async function UpdateStudentProfile(userUID , postBody){
    postBody.lastUpdateAt = serverTimestamp();
    const UpdateProfileRef = doc(getFirestore() , 'students' , userUID)
    return await updateDoc(UpdateProfileRef , postBody);
}


//* Exam Details Queries

async function saveStudentInExam(examDocID, userUID, postBody) {
    console.log('postBody: ', postBody);
    postBody.createdAt = serverTimestamp();
    const examRef = doc(getFirestore(), `exams/${examDocID}/Applicants`, userUID)
    return await setDoc(examRef, postBody);
}

async function updateStudentInExam(examDocID, userUID, postBody) {
    postBody.lastUpdateAt = serverTimestamp();
    const docRef = doc(getFirestore(), `exams/${examDocID}/Applicants`, userUID);
    return await updateDoc(docRef, postBody);
}

async function getStudentFromExam(examDocID, userUID) {
  const adminRef = doc(getFirestore(), `exams/${examDocID}/Applicants`, userUID)
  return await getDoc(adminRef);
}

//*My Exams

async function getExamByID(examID){
    const IDRef = doc(getFirestore() , 'exams', examID);
    return await getDoc(IDRef)
}


function getExamScheduleById(id) {
    return new Promise((resolve, reject) => {
        const examsref = collection(getFirestore(), 'exams/' + id + '/subExam');
        getDocs(examsref).then((resp) => {
            resolve(resp)
        }).catch((err) => {
            reject(err)
        })
    })
}

function getExamByExamShortName(examShortName) {
    return new Promise((resolve, reject) => {
        const examsref = collection(getFirestore(), 'exams');
        getDocs(query(examsref, where("examShortName", '==', examShortName))).then((resp) => {
            resolve(resp)
        }).catch(err => {
            reject(err);
        })
    })
}

//* Hall Tickets
async function getStudentHallTicket(examDocID, userUID) {
    const adminRef = doc(getFirestore(), `exams/${examDocID}/hallticket`, userUID)
    return await getDoc(adminRef);
  }

  async function getHallTicketWithPublishedExam(uid) {
    return new Promise((resolve, reject) => {
      let responseArray = [];
      getDocs(query(collectionGroup(getFirestore(), "hallticket"), where("UID", "==", uid))).then(res=>{
        let appliedList = res.docs.map(m=>({...m.data(), docId: m.id, examDocId:m.ref.parent.parent.id}));
        Promise.all(appliedList.map(m => getDoc(doc(getFirestore(), "exams", m.examDocId)))).then(response => {
          const publishedHallTicketExams = response.map(m => ({...m.data(), docId: m.id})).filter(f => f.hallTicketStatus === "published");
          appliedList.forEach((element, index) => {
            if (publishedHallTicketExams.some(s => s.docId === element.examDocId)) {
              responseArray.push({
                ...publishedHallTicketExams.find(s => s.docId === element.examDocId),
                hallTicketDetails: element
              })
            }
          })
          resolve(responseArray)
          console.log("responseArray" , responseArray)
        })
      }).catch(err=>{
        console.log(err);
        reject(err)
      })
    })
  }

  async function getAppliedExam(uid) {
    return new Promise((resolve, reject) => {
      let responseArray = [];
      getDocs(query(collectionGroup(getFirestore(), "EligibleStudents"), where("UID", "==", uid))).then(res=>{
        let appliedList = res.docs.map(m=>({...m.data(), docId: m.id, examDocId:m.ref.parent.parent.id}));
        Promise.all(appliedList.map(m => getDoc(doc(getFirestore(), "exams", m.examDocId)))).then(response => {
          const appliedExams = response.map(m => ({...m.data(), docId: m.id}));
          appliedList.forEach((element, index) => {
            if (appliedExams.some(s => s.docId === element.examDocId)) {
              responseArray.push({
                ...appliedExams.find(s => s.docId === element.examDocId),
                hallTicketDetails: element
              })
            }
          })
          resolve(responseArray)
          console.log("responseArray" , responseArray)
        })
      }).catch(err=>{
        console.log(err);
        reject(err)
      })
    })
  }

export {getFirebaseExams,  saveStudentInExam, getStudentFromExam, updateStudentInExam, getExamScheduleById, getExamByExamShortName , getApplicants, getExamByID , 
getStudents,  getNextPendingExams , getNextAdmitCard , UpdateStudentProfile, getStudentHallTicket , getAdmitApplicants , getStudentsData , getHallTicketWithPublishedExam , getAppliedExam }